<template>
  <div>
    <vx-card class="mb-5" title="Mis contratos." >
      <div class="vx-row">
        <div class="vx-col w-full">
          <p>
            Consulta los contratos que todos los integrantes de la Red aceptan al entrar a nuestra comunidad.
          </p>
        </div>
      </div>

      <div class="vx-row mt-6" v-if="allContracts.length > 0 && isMounted">
        <div class="vx-col w-full">
          <div class="flex flex-wrap items-center">
            <vs-button v-for="(contract, idx ) in allContracts" :type="contract.buttonStyle" class="sm:px-base px-4 mr-4 mb-3" :key="idx" @click="downloadContract(contract)">
              {{contract.name}}
            </vs-button>
          </div>
        </div>
      </div>

      <div class="vx-row mt-6" v-if="!isMounted">
        <div class="vx-col w-full">
          <div class="flex flex-wrap items-center">
            <p>Cargando información...</p>
          </div>
        </div>
      </div>
    </vx-card>
    
    <!-- CONTRATO COMISIÓN MERCANTIL -->
    <vx-card v-if="isMounted && merchantContractFAD !== undefined" class="mb-5" title="Contrato Comisión Mercantil">
      <div class="vx-row">
        <div class="vx-col w-full">
          <p><strong>Tipo de firma:</strong> Firma Autógrafa Digital (FAD). </p>
          <p><strong>Nota:</strong> Se requiere la firma de este contrato para la verificación del perfil.</p>
          <p class="mt-2">
            Considera que necesitarás un dispositivo móvil (celular o tablet) para realizar la Firma Autógrafa Digital (FAD). Además, será necesario que ingreses los últimos 4 dígitos del celular que registraste y que se indica en la tabla de firmantes.
            <a class="bold clickable" @click="goToTutorial()" target="_blank">¿Tienes dudas? Consulta este tutorial sobre cómo firmar un contrato con Firma Autógrafa Digital (FAD) dando clic aquí.</a>
          </p> <br>
          <!-- TABLA DE FIRMANTES -->
          <p class="bold primary mt-4">Por favor valida que los datos de correo y celular sean correctos. </p>
          <vs-table class="mt-2 mb-8" :data="handleSignatories(merchantContractFAD)" noDataText="No hay datos disponibles." stripe>
            <template slot="thead">
              <vs-th class="bold" v-for="(col, idx) in columnsSignatory" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].type">
                  {{ getRoles(data[indextr].type) }} 
                </vs-td>
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name != null && data[indextr].name != "" ? data[indextr].name : "Sin información" }}
                </vs-td>
                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email != null && data[indextr].email != "" ? data[indextr].email : "Sin información" }}
                </vs-td>
                <vs-td :data="data[indextr].telephone">
                  {{ data[indextr].telephone != null && data[indextr].telephone.phone != "" ? `${data[indextr].telephone.country_calling_code} ${phoneFormat(data[indextr].telephone.phone)}` : "Sin información" }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <!-- TABLA DE FIRMANTES -->
          <vs-divider></vs-divider>
          <!-- DETALLE DE CONTRATOS -->
            <p class="bold primary mt-4 ">Detalle de contratos</p>
            <div class="vx-row">
              <div class="vx-col lg:w-1/3 md:w-full sm:w-full" style="padding-left: 3rem;">
                <p class="bold mt-4 mb-2">Documentos</p>
                <ul class="ul-bullet">
                  <li>
                    Comisión Mercantil
                  </li>
                </ul>
              </div>
              <div class="vx-col lg:w-1/3 md:w-full sm:w-full"  style="padding-left: 3rem;">
                <p class="bold mt-4 mb-2">Información adicional</p>
                <ul class="ul-bullet">
                  <li>
                    <strong>Creado(s): </strong>{{ regularDateFormat(merchantContractFAD.created_at)}}
                  </li>
                  <li>
                    <strong>Estatus: </strong>{{status(merchantContractFAD)}}
                  </li>
                  <li>
                    <strong>Tipo de firma: </strong>{{signing_type(merchantContractFAD.signing_type)}}
                  </li> <br>
                  <li v-if="key !== null">
                    <strong>Key: </strong>{{key}}
                  </li>
                  <li v-if="key !== null">
                    <strong>Vector: </strong>{{vector}}
                  </li>
                </ul>
              </div>
              <div class="vx-col lg:w-1/3 md:w-full sm:w-full" style="padding-left: 3rem;">
              <p class="bold mt-4 mb-2">Acciones</p>
                <template>
                  <div v-if="status(merchantContractFAD) == 'Enviado'"  class="vx-row">
                    <div class="vx-col w-full">
                      <p class="bold text-sm">{{fadLink.type}}:</p>                
                      <div class="flex items-center">  
                        <vs-button size="small" type="border" icon="open_in_new" class="mb-2 mr-3" @click.stop="handleFadLink(fadLink.ticket)">Abrir</vs-button>
                        <vs-button size="small" type="border" icon="content_copy" class="mb-2 mr-3" @click.stop="copyToClipboard(fadLink.ticket)">Copiar</vs-button>
                      </div>
                    </div>
                  </div>
                </template>
                
                <vs-button
                  size="small" type="border" class="mb-2 mr-3" target color="danger"
                  @click="requestCancelCMContract()">
                  Cancelar <br>
                  Contrato
                </vs-button>

                <vs-button v-if="status(merchantContractFAD) == 'Generado'" 
                  size="small" type="border" class="mb-2 mr-3" target color="success"
                  @click="sendToFad()">
                  Enviar a<br>FAD
                </vs-button>

                <vs-button v-if="status(merchantContractFAD) == 'Firmado'" 
                  size="small" type="border" class="mb-2 mr-3" target color="success"
                  @click="downloadFADContract(merchantContractFAD.id, 'pdf_signed')">
                  Descargar PDF<br>firmado
                </vs-button>

                <vs-button 
                    size="small" type="border" class="mb-2 mr-3" target color="success"
                    @click="viewContractRequest(merchantContractFAD.id)">
                    Ver PDF<br>firmado
                  </vs-button>

                <vs-button v-if="status(merchantContractFAD) == 'Firmado'" 
                  size="small" type="border" class="mb-2" target color="success"
                  @click="downloadFADContract(merchantContractFAD.id, 'xml_signed')">
                  Descargar XML<br>firmado
                </vs-button>
              </div>
            </div>
            <!-- DETALLE DE CONTRATOS -->
        </div>
      </div>
    </vx-card>

    <vx-card v-else class="mb-5" title="Contrato Comisión Mercantil.">
      <p class="mb-2">
        Es de suma importancia que firmes el Contrato de Comisión Mercantil ya que este es uno de los documentos que te permiten operar dentro de la Red. Sin él no podrás llevar a cabo actividades fundamentales de la plataforma, como la recepción y aprobación de una de Solicitud de Crédito o recibir pagos de tus proyectos o instalaciones.
      </p>
      <p v-if="!isVerified" class="mb-3">
        Es necesario completar la información de tu perfil y la verificación de identidad del <strong>{{isPM ? 'Representante Legal' : 'Responsable / Dueño del Negocio'}}</strong>; una vez completado esto, aparecera un botón para poder generarlo y posteriormente firmarlo.
      </p>

      <div class="vx-row">
        <div class="vx-col w-full">
          <!-- TABLA DE FIRMANTES -->
          <p class="bold primary mt-4">Por favor valida que los datos de correo y celular sean correctos. </p>
          <vs-table class="mt-2 mb-8" :data="supplier" noDataText="No hay datos disponibles." stripe>
            <template slot="thead">
              <vs-th class="bold" v-for="(col, idx) in columnsSignatory" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].type">
                  {{ getRoles(data[indextr].type) }} 
                </vs-td>
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name != null && data[indextr].name != "" ? data[indextr].name : "Sin información" }}
                </vs-td>
                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email != null && data[indextr].email != "" ? data[indextr].email : "Sin información" }}
                </vs-td>
                <vs-td :data="data[indextr].telephone">
                  {{ data[indextr].telephone != null && data[indextr].telephone != "" ? `${data[indextr].telephone.country_calling_code} ${phoneFormat(data[indextr].telephone.phone)}` : "Sin información" }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <!-- TABLA DE FIRMANTES -->
      </div>
      
      <div class="vx-col w-full ">
        <div class="flex flex-wrap items-center">
          <vs-button type="border" class="sm:px-base px-4 mr-4 mb-3" @click="popupSpecial = true">
            Ver Contrato Comisión Mercantil
          </vs-button>
          <vs-button v-if="isVerified" class="sm:px-base px-4 mr-4 mb-3" @click="requestFAD()">
            Generar Contrato Comisión Mercantil
          </vs-button>
        </div>
      </div>
    </vx-card>
    <!-- CONTRATO COMISIÓN MERCANTIL -->
    
    <vs-popup fullscreen :active.sync="popupActive" title="Contrato" >
      <vx-card class="mb-5" title="EL CONTRATO" title-color="primary" >
        <terms-contract v-if="termsActive" />
        <privacy-contract v-if="privacyActive" />
        <knowledge-clauses v-if="knowledgeActive" />
      </vx-card>
      <vx-card class="mb-2" title-color="primary" title="TU FIRMA">
        <h5>Datos de la firma:</h5>
        <p class="my-2"><span class="bold">Nombre del documento: </span> {{currentMetaData.document}}</p>
        <p class="my-2"><span class="bold">Versión del documento: </span> {{currentMetaData.version}}</p>
        <p class="my-2"><span class="bold">Fecha de aceptación: </span> {{signatureFormatDate(currentMetaData.acceptance_date)}}</p>
        <p class="my-2"><span class="bold">Agente: </span> {{currentMetaData.agent}}</p>
        <p class="my-2"><span class="bold">IP: </span> {{currentMetaData.ip}}</p>
        <!--p class="my-2"><span class="bold">Validez del documento: </span> {{signatureValidityDate(currentMetaData.validity_date)}}</p-->
        <p class="my-2"><span class="bold">Correo electrónico: </span> {{currentMetaData.email}}</p>


        <h5 class="mt-5">Cadena de firma electrónica:</h5>
        <p class="text-break text-xs my-2">{{currentSignature}}</p>
      </vx-card>
    </vs-popup>

    <vs-popup fullscreen :active.sync="popupSpecial" title="Contrato">
      <vx-card class="mb-5" title="EL CONTRATO" title-color="primary" >
        <merchant-commission/>
      </vx-card>
    </vs-popup>
  </div>
</template>

<script>
import TermsContract from "@contracts/TermsContract";
import PrivacyContract from "@contracts/PrivacyContract";
import MerchantCommission from "@supplier/contracts/MerchantCommission";
import KnowledgeClauses from "@supplier/contracts/KnowledgeClauses";
import dateHelper from "@mixins/dateHelper";
import formatHelper from '@components/mixins/formatHelper';

const tutorialFADLink = "https://youtu.be/19npgHmTUi0";
const FADLinkBaseDevelopment = "https://uatwebfad.firmaautografa.com/signList?ticketReq=";
const FADLinkBaseProduction = "https://mobile.firmaautografa.com/main?ticket=";

const columnsSignatory = [
  { title: "FIRMANTE", kye: "signatory", sortable:false }
  , { title: "NOMBRE", kye: "name", sortable:false }
  , { title: "CORREO", kye: "email", sortable:false }
  , { title: "CELULAR", kye: "telephone", sortable:false }
];

export default {
  name: "ContractsPage",
  props: ['supplier_id', 'isVerified', 'isPM', 'supplier'],
  data() {
    return {
      fixedContracts: [
        {id: 1, name: 'Términos y condiciones', url: 'terminos-y-condiciones', type: 1, buttonStyle: 'border' },
        {id: 2, name: 'Aviso de privacidad', url: 'aviso-de-privacidad', type: 2, buttonStyle: 'border' },
        {id: 3, name: 'Comisión mercantil', url: 'contrato-de-comision-mercantil-instalador', type: 5, buttonStyle: 'border' },
        {id: 4, name: 'Constancia de Conocimiento', url: 'constancia-de-conocimiento-proveedor', type: 14, buttonStyle: 'filled' }
      ],

      signedContracts:[],
      hasSignedContracts: false,
      allContracts: [],
      termsActive: false,
      privacyActive: false,
      merchantActive: false,
      knowledgeActive: false,
      popupActive: false,
      currentSignature: null,
      isMounted: false,
      currentMetaData: {
        acceptance_date: null,
        agent: null,
        alias: null,
        email: null,
        document: null,
        ip: null,
        password: null,
        validity_date: null,
        version: null,
      },
      currentSupplierId: null,
      merchantContractFAD: [],
      merchantContractFADType: 5,
      tutorialFADLink: tutorialFADLink
      , columnsSignatory: columnsSignatory
      , fadLink: {}
      , FADLinkBase: process.env.VUE_APP_ENV == "production" ? FADLinkBaseProduction : FADLinkBaseDevelopment
      , popupSpecial: false
      , knowledgeContractType : 14
      , vector: null
      , key: null
    }
  },
  mixins: [dateHelper, formatHelper],
  components: {
    TermsContract,
    PrivacyContract,
    MerchantCommission,
    KnowledgeClauses
  },
  async mounted(){
    this.isMounted = false
    this.showLoading(true)
    await this.getContractsData();
    this.isMounted = true;
    this.showLoading(false);
  },
  computed: {
    // accessToken(){
    //   return this.AccessToken;
    // },
  },
  methods: {
    async sendToFad() {
      this.showLoading(true);
      try {
        const res = await axios.post(`api/supplier/send-to-fad/merchant-contract/${this.supplier_id}`);
        if(res.data == "OK"){
          this.merchantContractFAD.status = "sent";
          this.successNotif("El contrato de comisión mercantil se envió a firma con FAD.");
        } else {
          this.errorNotif("Algo ha salido mal, el contrato no se envió a firma.");
        }
        this.showLoading(false);
      } catch (error) {
        console.log(error);
      }
      this.showLoading(false);
    },
    async downloadContract(contract){
      if(contract.isSigned){
      await this.downloadSignedContract(contract);
      } else {
        if(contract.type !== this.knowledgeContractType){ // Constancia conocimiento
          const url = `${this.ApiDomain}/${contract.url}`;
          window.open(url, '_blank');
        } else {
          // this.$router.push({ name: 'KnowledgeContract' });
          this.warningNotifDialog("Atención.", "El insatalador no ha aceptado la Constancia Conocimiento, es importante que la acepte para no frenar la originación.")
        }
      }
    },

    async downloadSignedContract(obj){
      if(obj.signature != null){
        this.currentSignature = obj.signature;
        this.currentMetaData = obj.metadata;
        this.popupActive = true;

        switch(obj.type){
          case 1:
            this.termsActive = true;
            this.privacyActive = false;
            this.merchantActive = false;
            this.knowledgeActive = false;
            break;
          case 2:
            this.privacyActive = true;
            this.termsActive = false;
            this.merchantActive = false;
            this.knowledgeActive = false;
            break;
          case 5:
            this.merchantActive = true;
            this.privacyActive = false;
            this.termsActive = false;
            this.knowledgeActive = false;
            break;
          case 14:
            this.merchantActive = false;
            this.privacyActive = false;
            this.termsActive = false;
            this.knowledgeActive = true;
            break;
        }
      }
    },
    async getContractsData(){
      try {
        const res = await axios.get(`api/supplier/${this.supplier_id}/get-contracts`);
        this.signedContracts = res.data.supplier;
        this.hasSignedContracts = res.data.supplier && res.data.supplier.length > 0;
        this.merchantContractFAD = res.data.supplier.find(c => c.type === this.merchantContractFADType);
        if(this.merchantContractFAD !== undefined && this.merchantContractFAD !== null){
          this.buildFADLinks(this.merchantContractFAD);
        }
        const defaultContracts = res.data.default;
        const supContracts = res.data.supplier;
        let allContracts = [];

        defaultContracts.forEach(df => {
          if(df.type !== 5){
            const fsup = this.fixedContracts.find(f => f.type === df.type);
            let sup = null;
            if(df.type === 1 || df.type === 2){
              try {
                sup = supContracts.find(f => f.contract.type === df.type);
                if(sup != null && sup != undefined){
                  allContracts.push({
                    name: df.name,
                    type: df.type,
                    url: fsup.url,
                    isSigned: (sup.signature != null),
                    signature: sup.signature ?? null,
                    metadata: sup.metadata ?? null,
                    buttonStyle: fsup.buttonStyle
                  });
                }
              } catch (error) {
                allContracts.push({
                  name: fsup.name,
                  type: df.type,
                  url: fsup.url,
                  isSigned: false,
                  signature: null,
                  metadata: null,
                  buttonStyle: fsup.buttonStyle
                });
              }
            } else if(df.type === 14) {
              allContracts.push(this.handleKnowledgeContract(fsup,supContracts,df));
            }
            this.allContracts = allContracts;
          }
        });
      }
      catch (e) {
        console.log(e);
      }
    },
    handleKnowledgeContract(fixedContract, contracts, contract){
      let obj = {
        name: contract.name
        , type: contract.type
        , url: fixedContract.url
        , buttonStyle: fixedContract.buttonStyle
        , isSigned: false
        , signature: null
        , metadata: null
      };
      let index = contracts.findIndex(item => item.status === "generated");
      if(index === -1){
        const c = contracts.find(item => (item.contract !== undefined ? item.contract.type : item.type === contract.type));
        if(c !== null&& c !== undefined){
          if(c.hasOwnProperty('metadata') && c.hasOwnProperty('contract')){
            obj.isSigned = (c.signature != null);
            obj.signature = c.signature ?? null;
            obj.metadata = c.metadata ?? null;
          }
        }
      }

      return obj;
    },
    handleSignatories(data){
      if(data !== undefined && data !== null){
        let arraySignatories = JSON.parse(data.signatories);
        if (arraySignatories != null){  
          return [arraySignatories.supplier];
        } 
      }
      return [];
    },
    getRoles(role){
      let r = "";
      switch(role){
        case "customer":
          r = "Solicitante";
        break;
        case "supplier":
          r = "Proveedor";
        break;
        case "redgirasol":
          r = "RedGirasol";
        break;
        default: r = "Obligado Solidario";
      }

      return r;
    },
    signing_type(wish){
      let r = "";
      switch(wish){
        case 1:
          r = "Manual Autógrafa";
        break;
        case 2:
          r = "Electrónico";
        break;
        case 3:
          r = "Firma Autógrafa Digital (FAD)";
        break;
        default: r = "--";
      }
      return r;
    },
        
    status (contract){
      if(contract.status == 'generated'){
         return "Generado";
      }
      else if(contract.status == 'sent'){
         return "Enviado";
      }
      else if(contract.status == 'signed'){
         return "Firmado";
      }
    },
    buildFADLinks(contract){
      if (contract.fad_requisition != null){
        let requisition = JSON.parse(contract.fad_requisition);
        let index = 0;
        let allTickets = Object.values(requisition.allTickets);
        this.vector = requisition.vector;
        this.key = requisition.key;
  
        allTickets.forEach(ticket => {
          if(index == 0){
            this.fadLink.type =  "Proveedor";
          } else {
            this.fadLink.type = "N/A";
          }
          this.fadLink.ticket = ticket;
          index++;
        });
      }
    },
    copyToClipboard(ticket){
      const el = document.createElement('textarea');
      el.value = this.FADLinkBase + ticket;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.successNotif("Liga copiada al portapapeles");
    },
    handleFadLink(ticket){
      window.open(this.FADLinkBase + ticket, '_blank');
    },
    requestCancelCMContract() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Cancelar contrato de comisión mercantil',
        text: `¿Estás seguro de cancelar el contrato de comisión mercantil? Esta acción cancelara la firma en la plataforma FAD también.`,
        acceptText: "Si, cancelar",
        cancelText: 'Cancelar',
        accept: this.doRequestCancel
      });
    },
    async doRequestCancel(){
      try{
        this.showLoading(true)
        const res = await axios.post(`api/supplier/contracts/${this.supplier_id}/cancel`, {
          "contract_id": this.merchantContractFAD.id
        });
        this.isMounted = false
        await this.getContractsData();
        this.isMounted = true;
        this.successNotifDialog("Contrato cancelado", "Ya puedes notificar el estatus del Contrato de Comisión Mercantil.")
      }catch(e) {
        console.log("No se generó la firma con FAD.");
        this.failedOperationNotif();
      } finally {
        this.showLoading(false);

      }
    },
    requestFAD(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Iniciar proceso de firma',
        text: `Estás por iniciar el proceso de firma del Contrato de Comisión Mercantil, este proceso no tomará más de 5 minutos, sin embargo una vez iniciado tendrás un plazo de 7 días para concluirlo. ¿Deseas comenzar el proceso de firma?`,
        acceptText: "Si, comenzar ahora",
        cancelText: 'Cancelar',
        accept: this.doRequestFAD
      });
    },
    async doRequestFAD(){
      try{
        this.showLoading(true)
        const res = await axios.post(`api/supplier/send/merchant-contract/${this.supplier_id}`);
        this.isMounted = false
        await this.getContractsData();
        this.isMounted = true;
        this.successNotifDialog("Proceso iniciado", "Ya puedes firmar el Contrato de Comisión Mercantil a través de la Firma Autógrafa Digital dando clic desde tu dispositivo móvil en la opción <<Abrir>>")
      }catch(e) {
        console.log("No se generó la firma con FAD.");
        this.failedOperationNotif();
      } finally {
        this.showLoading(false);

      }
    },
    viewContractRequest(contract_id){
      let url = `${this.ApiDomain}/api/supplier/pdf_signed/contracts/view/contract/${contract_id}/?access_token=${this.AccessToken}`
      try {
        window.open(url,url,'addressbar=0,directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=0,resizable=0,height=700,width=800');
      } catch (error) {
        
      }
    },
    goToTutorial(){
      try{
        window.open(this.tutorialFADLink,"_blank");
      } catch (err) {
        console.error("Algo salió mal con el link del tutorial.", err);
        this.errorNotif();
      }
    },
    downloadFADContract(contract_id, document_type){
      try {
        let id = parseInt(contract_id);
        let url = `${this.ApiDomain}/api/supplier/${document_type}/contracts/download/contract/${id}/?access_token=${this.AccessToken}`;
        window.open(url, '_blank');
      } catch (error) {
        console.error("Algo salió mal con el link de FAD para ver archivos.", err);
        this.errorNotif();
      }
    }
  }
}
</script>

<style scoped>
  .text-break {
    overflow-wrap: break-word;
  }
  .clickable {
    cursor: pointer;
  }
</style>